import React, { useState, useEffect } from "react";
import { Table, Input, Typography, Card, Button, Form, message, Space, Segmented, Popconfirm } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import './QueueTable.css'
import axios from 'axios';
import { REGEX, LAMBDAS } from "../../literals";

const { Search } = Input;
const {Title} = Typography;

const parseWaitTime = (WaitTime) => {
    const [hours, minutes, seconds] = WaitTime.split(":").map(Number);
    return (hours * 60) + minutes + (seconds / 60);
};

const getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Search
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ width: 200, marginBottom: 8, display: "block" }}
      />
      <div>
        <button onClick={() => confirm()} style={{ marginRight: 8 }}>Search</button>
        <button onClick={() => { clearFilters(); window.location.reload(); }}>Reset</button>
      </div>
    </div>
  ),
  filterIcon: filtered => <span style={{ color: filtered ? "#1890ff" : undefined }}>🔍</span>,
  onFilter: (value, record) => record[dataIndex].toLowerCase().includes(value.toLowerCase()),
});

const columns = [
  { title: "Contact ID", dataIndex: "ContactID", key: "ContactID", 
    render: ContactID => (<a href={`https://ks-covid-19-hotline.my.connect.aws/contact-trace-records/details/${ContactID}?tz=America/Chicago`} target="_blank" rel="noopener noreferrer">
    {ContactID}</a>), 
    sorter: (a, b) => a.ContactID.localeCompare(b.ContactID),
    ...getColumnSearchProps("ContactID") },
  { title: "Queue Name", dataIndex: "QueueName", key: "QueueName", ...getColumnSearchProps("QueueName") },
  /*{
    title: "Oldest Contact Timestamp",
    dataIndex: "oldestContactTimestamp",
    key: "oldestContactTimestamp",
    sorter: (a, b) => new Date(a.oldestContactTimestamp) - new Date(b.oldestContactTimestamp),
    ...getColumnSearchProps("oldestContactTimestamp")
  },*/
  { title: "Caller's Phone Number", dataIndex: 'PhoneNumber', key: 'PhoneNumber', ...getColumnSearchProps('PhoneNumber')},
  { title: "Position In Queue", dataIndex: "Position", key: "Position", sorter: (a, b) => a.Position - b.Position },
  { title: "Call Wait Time", dataIndex: "WaitTime", key: "WaitTime",
    sorter: (a, b) => {
        const timeA = parseWaitTime(a.WaitTime);
        const timeB = parseWaitTime(b.WaitTime);
        return timeB - timeA;
    },render: time => <span style ={{ color: parseWaitTime(time) > 120 ? "red" : "black"}}>{time}</span>, ...getColumnSearchProps("WaitTime") },
 // { title: "Agent In Contact", dataIndex: "agentInContact", key: "agentInContact", ...getColumnSearchProps("agentInContact") },
  //{ title: "Transferred From", dataIndex: "transferredFrom", key: "transferredFrom", ...getColumnSearchProps("transferredFrom") },
 // { title: "Transfer To", dataIndex: "transferTo", key: "transferTo", ...getColumnSearchProps("transferTo") }
];


const localData = [
  { ContactID: "42d92881-24d9-418a-9a00-56a5971c1956", QueueName: "Blue Queue", oldestContactTimestamp: "2025-06-06T07:45:00Z", PhoneNumber: '+12301654321', Position: 3, WaitTime: "02:03:25", agentInContact: "John Doe", transferredFrom: "LIEAP", transferTo: "Child care" },
  { ContactID: "B2d92881-1rd9-418a-ga00-56a5971c195s", QueueName: "Red Queue", oldestContactTimestamp: "2025-06-02T02:40:00Z", PhoneNumber: '+12301651234', Position: 2, WaitTime: "03:01:15", agentInContact: "Lewis Smith", transferredFrom: "General Inquiry", transferTo: "HSS" },
  { ContactID: "22d92881-34d9-i18a-6a00-56a5971c1953", QueueName: "Green Queue", oldestContactTimestamp: "2025-06-07T07:40:00Z", PhoneNumber: '+12301652134', Position: 1, WaitTime: "01:01:15", agentInContact: "Kelly Smith", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "k2d92881-34d9-i18a-6a00-56a5971c1951", QueueName: "Purple Queue", oldestContactTimestamp: "2025-06-01T07:40:00Z", PhoneNumber: '+12301652134', Position: 4, WaitTime: "02:11:15", agentInContact: "Dane Smith", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "I2d92881-34d9-i18a-6a00-56a5971c1921", QueueName: "Blue Queue", oldestContactTimestamp: "2025-06-03T07:40:00Z", Position: 8, WaitTime: "03:08:15", agentInContact: "Angie Smith", transferredFrom: "IR", transferTo: "Employement services" },
  { ContactID: "N2d92881-34d9-i18a-6a00-56a5971c1950", QueueName: "IR Queue", oldestContactTimestamp: "2025-06-04T07:40:00Z", Position: 5, WaitTime: "04:01:26", agentInContact: "Flict Stone", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "O2d92881-34d9-i18a-6a00-56a5971c195C", QueueName: "Purple Queue", oldestContactTimestamp: "2025-06-05T07:40:00Z", Position: 6, WaitTime: "01:13:15", agentInContact: "Jane MCAurthur", transferredFrom: "HSA", transferTo: "Employement services" },
  { ContactID: "P2d92881-34d9-i18a-6a00-56a5971c195K", QueueName: "Red Queue", oldestContactTimestamp: "2025-06-06T08:40:00Z", Position: 7, WaitTime: "02:01:45", agentInContact: "Sandra Bullock", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "82d92881-34d9-i18a-6a00-56a5971c195S", QueueName: "Blue Queue", oldestContactTimestamp: "2025-06-07T03:40:00Z", Position: 9, WaitTime: "00:41:15", agentInContact: "Flow Clade", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "Z2d92881-34d9-i18a-6a00-56a5971c1958", QueueName: "Green Queue", oldestContactTimestamp: "2025-05-06T07:40:00Z", Position: 10, WaitTime: "00:35:15", agentInContact: "Jane Rice", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "Q2d92881-34d9-i18a-6a00-56a5971c195g", QueueName: "Red Queue", oldestContactTimestamp: "2025-06-01T07:30:00Z", Position: 13, WaitTime: "00:21:55", agentInContact: "xavier Smith", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "M2d92881-34d9-i18a-6a00-56a5971c1952", QueueName: "Green Queue", oldestContactTimestamp: "2025-06-04T11:40:00Z", Position: 11, WaitTime: "00:40:25", agentInContact: "Joan Clark", transferredFrom: "General Inquiry", transferTo: "Employement services" },
  { ContactID: "U2d92881-34d9-i18a-6a00-56a5971c195T", QueueName: "Purple Queue", oldestContactTimestamp: "2025-06-05T12:40:00Z", Position: 12, WaitTime: "00:33:15", agentInContact: "Janet Menson", transferredFrom: "General Inquiry", transferTo: "Employement services" },
];

const QueueTable = (props) => {
  // const [data] = useState(localData);
  const agentID = props.agentID;
  const [dataSource, setDataSource] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [isFirstLoad, setIsFirstLoad] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)

  useEffect(() => {
    if (!isFirstLoad || isRefreshing) {
      console.log("AGENTID: ", agentID)
      axios({
        method: 'POST',
        baseURL: LAMBDAS.CURRENT_CALLS,
        headers: { authorizationToken: agentID },
        data: {},
      }).then((response) => {
        console.log("RESPONSE DATA CALLERS: ", response.data.body)

        setDataSource(response.data.body)

      }).catch((error) => {
        console.log(error);
      });
      setIsFirstLoad(true)
      setIsRefreshing(false)
    }

  }, [isFirstLoad, isRefreshing])

  useEffect(() => {
    // Set up an interval to refresh every 1 minute (60,000 ms)
    const intervalId = setInterval(() => {
      setIsRefreshing(true)
    }, 60000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={{ padding: 24, backgroundColor: '#f0f2f5'}}>
      {/* <Title level={2} className="header-title"> Real-Time Callers Data</Title> */}
      <Card title="Real-Time Callers Data" hoverable>
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey="ContactID"
      pagination={{
        pageSize: 5,
        current: currentPage,
        showSizeChanger: false,
        onChange: page => setCurrentPage(page)
      }}
    />
    <Form.Item>
        <Space>
          <Button htmlType="button" onClick={() => { setIsRefreshing(true) }}>
            Refresh Caller Data
          </Button>
        </Space>
      </Form.Item>
    </Card>
    </div>
  );
};

export default QueueTable;

